define('EideBailly.ProductInventoryByLocation.ProductInventoryByLocation', [
	'EideBailly.ProductInventoryByLocation.ProductInventoryByLocation.View',
	'ProductInventoryByLocation.Model',
	'AjaxRequestsKiller',
], function (
	ProductInventoryByLocationView,
	ProductInventoryByLocationModel,
	AjaxRequestsKiller
) {
	'use strict';

	return {
		mountToApp: function mountToApp(container) {
			if (!SC.isPageGenerator()) {
				var pdp = container.getComponent('PDP');
				if (pdp) {
					pdp.on('beforeShowContent', function () {
						var pdpItemId = pdp.getItemInfo().item.internalid + '';
						var model = new ProductInventoryByLocationModel();
						model.fetch({
							data: {
								internalid: pdpItemId,
								action: 'getLocationInventory',
							},
							killerId: AjaxRequestsKiller.getKillerId(),
						});

						pdp.addChildViews(pdp.PDP_FULL_VIEW, {
							StockDescription: {
								PurchaseRestrictionView: {
									childViewIndex: 5,
									childViewConstructor: function () {
										return new ProductInventoryByLocationView({
											internalid: pdpItemId,
											model: model,
										});
									},
								},
							},
						});

						pdp.addChildViews(pdp.PDP_QUICK_VIEW, {
							StockDescription: {
								PurchaseRestrictionView: {
									childViewIndex: 5,
									childViewConstructor: function () {
										return new ProductInventoryByLocationView({
											internalid: pdpItemId,
											model: model,
										});
									},
								},
							},
						});

					});
				}
			}
		},
	};
});
